import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import * as AccountsManualStepViews from './AccountsManualStepViews';
import { isVisible } from '../../AdvWorkflow/AdvWorkflowHelpers';
import AccountsOverview from './AccountsOverviewContainer';
import AccountAddEdit from './AccountAddEditContainer';
import { createCustomPropType, isNumeric } from '../../../../js/app/react/validators';
import accountsManualStepShouldSkip from './AccountsManualStepShouldSkip';
import PlaidLinkingStep from './PlaidLinkingStep/PlaidLinkingStep';
import InstitutionSearchContainer from '../../../Quovo/components/QuovoSearchInstitution/QuovoSearchInstitutionContainer';
import BackButton from '../../Navigation/Back/BackView';
import { BACKEND_KEY } from '../FinancialAccountsWorkflowConstants';

class AccountsStepView extends Component {
  constructor(props) {
    super(props);
    this.onSpinnerRef = this.onSpinnerRef.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { branch, iterator, viewId, fetchData, workflowId, clientId, dirtyNodesMap } = this.props;

    if (!isVisible(branch, iterator)) {
      return;
    }

    if (!isVisible(prevProps.branch, prevProps.iterator)) {
      fetchData(workflowId, clientId, dirtyNodesMap);
      return;
    }

    if (viewId !== AccountsManualStepViews.OVERVIEW) {
      return;
    }

    if (prevProps.viewId === AccountsManualStepViews.OVERVIEW) {
      return;
    }
    fetchData(workflowId, clientId, dirtyNodesMap);
  }

  onSpinnerRef(ref) {
    if (ref) {
      this.spinner = new window.ADV.util.Spinner();
    } else {
      this.spinner.destroy();
    }
  }

  render() {
    const { branch, workflowId, viewId, isBusy, onBack } = this.props;
    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={accountsManualStepShouldSkip()}
        {...(viewId === AccountsManualStepViews.OVERVIEW
          ? {
              id: 'AccountsOverviewViewStep',
            }
          : {})}
      >
        {isBusy && <div ref={this.onSpinnerRef} />}
        <div>
          {viewId === AccountsManualStepViews.OVERVIEW && (
            <AccountsOverview branch={branch} workflowId={workflowId} />
          )}
          {viewId === AccountsManualStepViews.ADD && (
            <AccountAddEdit branch={branch} workflowId={workflowId} />
          )}
          {viewId === AccountsManualStepViews.EDIT && (
            <AccountAddEdit branch={branch} workflowId={workflowId} />
          )}
          {viewId === AccountsManualStepViews.LINK && (
            <>
              <BackButton
                isBusy={false}
                onBack={() => () => onBack(workflowId)}
                workflowId={workflowId}
                validationId={`${BACKEND_KEY}.AccountsLinkingSteps`}
              />
              <InstitutionSearchContainer workflowId={workflowId} />
            </>
          )}
          {viewId === AccountsManualStepViews.PLAID && (
            <div style={{ minWidth: '600px' }}>
              <PlaidLinkingStep workflowId={workflowId} />
            </div>
          )}
        </div>
      </AdvWorkflowStep>
    );
  }
}

AccountsStepView.defaultProps = {
  iterator: null,
};

AccountsStepView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number).isRequired,
  iterator: PropTypes.arrayOf(PropTypes.number),
  workflowId: PropTypes.string.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  viewId: PropTypes.oneOf(Object.values(AccountsManualStepViews)).isRequired,
  fetchData: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  isBusy: PropTypes.bool.isRequired,
  dirtyNodesMap: PropTypes.shape({}).isRequired,
};

export default AccountsStepView;
